module.exports = __webpack_public_path__ + "img/danger.ac992464.svg";